module.exports = __webpack_public_path__ + "static/media/plus-square.ab32b181.svg";